import React, { Component } from 'react';
import { Container as Sidebar } from 'modules/sidebar';
import { Container as Header, Bar, Search, AffixSearch } from 'modules/header';
import { Footer } from 'modules/footer';
import { Spin, Modal, Row, Col, Affix, Button } from 'antd';
import _ from 'lodash';
import classnames from 'classnames';

export default class PcLayout extends Component {
  state = {
    showAffix: false,
  }
  render() {
    window.onscroll = () => {
      if (document.body.scrollTop >= 184 && !this.state.showAffix) {
        this.setState({
          showAffix: true
        })
      }
      if (document.body.scrollTop < 184){
        this.setState({
          showAffix: false
        })
      }
    }
    const {pathname, sidebar, body} = this.props;
    let hide = 'true';
    return (
      <div className="base-layout">
        <div>
          <div>
            <Header />
          </div>
          <div>
            <Bar />
          </div>
          {pathname !== 'home' &&
            <div className={classnames({"hide": !this.state.showAffix})}>
              <Affix>
                <div className={classnames("affix-search-layout", {"affix-move": this.state.showAffix})}>
                  <AffixSearch />
                </div>
              </Affix>
            </div>
          }
          <div className="base-content">
            <Row>
              <Col span="4">
                <Sidebar>
                  {sidebar}
                </Sidebar>
              </Col>
              <Col span="20">
                {body}
              </Col>
            </Row>
          </div>
          <div>
            <Footer />
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/base/components/PcLayout.js
 **/